<template>
  <div class="task-theory">
    <page-loader v-if="!isLoaded"></page-loader>
    <div class="task-text" v-html="task.theory">
    </div>
    <div class="center-obj">
      <div id="code"></div>
      <button class="btn btn-blue" v-on:click="startTask">Start task!</button>
    </div>
    <div class="center-obj">
      <button class="btn btn-default" v-on:click="nextToCourseMap">Back to course</button>
    </div>
  </div>
</template>

<script>
    import {GET_TASK, TASK_REQUEST, USER_TASK_START} from "../../../store/actions/task";
    import {COURSE_REQUEST, GET_COURSE} from "../../../store/actions/course";
    import {TaskFilter} from "../../../models/taskFilter";
    import CodeMirrorHelper from "../../../utils/codemirror"
    import PageLoader from "../../../components/PageLoader";

    export default {
        name: "Theory",
        components: {PageLoader},
        props: ['courseId', 'id'],
        data() {
            return {
                isLoaded: false,
                task: {
                    theory: ''
                }
            }
        },
        created() {
            this.$store.dispatch(TASK_REQUEST, new TaskFilter({
                courseId: this.courseId
            }));

            this.prepareData(this.$store.getters.getTasks);

            this.$store.watch(
                (state, getters) => getters.getTasks,
                (tasks) => {
                    this.prepareData(tasks);
                },
            );
        },
        methods: {
            prepareData(tasks) {
                if (tasks.length <= 0) return;

                if (tasks.find(task => task.courseId === this.courseId)
                    && !tasks.find(task => task.id === this.id))
                {
                    this.$router.push({
                        name: 'NotFound'
                    });
                }
                else {
                    this.task = tasks.find(task => task.id === this.id);
                    setTimeout(() => this.initCodeAreas(), 10);
                }
            },
            initCodeAreas() {
                let codeAreaElements = document.querySelectorAll('.codeeditor');

                codeAreaElements.forEach(element => {
                    if(!element.children[0])
                      CodeMirrorHelper.initCodeMirrorArea(element, element.dataset.codeType, element.dataset.code, true);
                });

                window.scrollTo({top: 0});
                this.isLoaded = true;
            },
            startTask() {
                this.$store.dispatch(USER_TASK_START, this.id).then(userTaskId => {
                    this.$router.push({
                        name: 'TaskWorkflow',
                        params: {
                            courseId: this.courseId,
                            id: this.id
                        }
                    });
                }).catch(err => console.log(err));
            },
            nextToCourseMap() {
                this.$router.push({
                    name: 'CourseMap',
                    params: {
                        id: this.courseId
                    }
                });
            }
        },
        watch: {
            $route(to, from) {
                this.prepareData(this.$store.getters.getTasks);
            }
        }
    }
</script>

<style lang="scss">
  .CodeMirror {
    margin: 25px 0;
  }

  .task-theory {
    position: relative;

    &-loading {
      overflow: hidden;
    }
  }
</style>
